/* eslint-disable no-unused-vars */
import object from "auth0-js/src/helper/object";
import { cloneDeep as _cloneDeep } from "lodash";

export default {
  SET_CLIENT_SESSION_ID(state, val) {
    state.clientSessionId = val;
  },
  SET_SELECTED_PRODUCT(state, val) {
    if (val) {
      state.selectedProduct = val.product;
      if (val.sizeId) state.selectedProduct.sizeId = val.sizeId;
      else state.selectedProduct.sizeId = null;
    } else state.selectedProduct = val;
  },
  SET_PRE_SELECTED_PRODUCT(state, val) {
    state.preSelectedProduct = val;
  },
  SET_UPDATE_ENTRY(state, val) {
    state.toUpdateEntry = val;
  },
  ADD_TO_CART(state, val) {
    let activeCart = state.carts.find(x => x.active);
    activeCart.cartEntries.push(val);
    activeCart.totalPrice = 0;
    activeCart.cartEntries.forEach(item => {
      activeCart.totalPrice += item.price;
    });
    activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;
    if (activeCart.totalPayedPrice == null) activeCart.totalPayedPrice = 0;
  },
  UPDATE_TO_CART(state, obj) {
    if (obj) {
      let activeCart = state.carts.find(x => x.active);

      // Önce mevcut cartEntries'in bir kopyasını oluştur
      const updatedCartEntries = [...activeCart.cartEntries];

      // İlgili index'teki elemanı çıkar ve yenisini ekle
      updatedCartEntries.splice(obj.index, 1, obj.entry);

      // Tüm array'i yeniden ata
      activeCart.cartEntries = updatedCartEntries;

      // Toplam fiyatı hesapla
      activeCart.totalPrice = 0;
      activeCart.cartEntries.forEach(item => {
        activeCart.totalPrice += item.price;
      });
      activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;
      if (activeCart.totalPayedPrice == null) activeCart.totalPayedPrice = 0;
    }
    state.toUpdateEntry = null;
},
  REMOVE_ENTRY_FROM_CART(state, val) {
    const entry = val && val.entry != null ? val.entry : val;
    if (!entry || entry.id == null) return;
    let activeCart = state.carts.find(x => x.active);
    let index = activeCart.cartEntries.findIndex(x => x.id == entry.id);
    if (index < 0) return;
    activeCart.cartEntries.splice(index, 1);
    activeCart.totalPrice = 0;
    activeCart.cartEntries.forEach(item => {
      activeCart.totalPrice += item.price;
    });
    activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;
    if (activeCart.totalPayedPrice == null) activeCart.totalPayedPrice = 0;
  },
  CREATE_NEW_CART(state, val) {
    state.carts.forEach(x => {
      x.active = false;
    });
    if (val && val.totalPayedPrice == null) val.totalPayedPrice = 0;
    state.carts.push(val);
  },
  REMOVE_THE_CART(state, val) {
    let currentCartIndex = state.carts.findIndex(x => x.id == val);
    if (currentCartIndex == 0 && state.carts.length == 1) {
      state.carts.splice(0, 1);
      state.carts.push({
        id: 0,
        cartEntries: [],
        totalPrice: 0,
        totalPayedPrice: 0,
        active: true
      });
    } else if (currentCartIndex >= 0) {
      state.carts.splice(currentCartIndex, 1);
      state.carts.forEach((item, index) => {
        item.id = index;
      });
      state.carts[state.carts.length - 1].active = true;
    }
  },
  SET_CURRENT_CART(state, val) {
    state.carts.forEach(x => {
      if (x.id == val.id) {
        x.active = true;
      } else {
        x.active = false;
      }

    });
  },
  SET_CURRENT_CART_WITH_CAMPAIGN(state,val){
    let cart = state.carts.find(x => x.active);
    cart.cartEntries = _cloneDeep(val);
    cart.totalPrice = 0;
    (cart.cartEntries || []).forEach(item => {
      cart.totalPrice += Number(item && item.price) || 0;
    });
    cart.totalPrice = Math.round(cart.totalPrice * 100) / 100;
    if (cart.totalPayedPrice == null) cart.totalPayedPrice = 0;
  },
  SET_ACTIVE_PERSONAL(state, val) {
    state.activePersonal = val;
    if (val != null) {
      state.screenLock = false;
    }
  },
  SET_SCREEN_LOCK(state, val) {
    state.screenLock = val;
  },
  SET_PIN_ENTRY_OPEN(state, val) {
    state.pinEntryOpen = val;
  },
  SET_IS_LOADING(state,val){
    state.isLoading =val;
  },
  SET_PERSON_LIST(state, val) {
    state.personList = val;
  },
  SET_IS_RESET(state, val) {
    state.isReset = val;
  },
  BUMP_PRODUCT_NAV_RESET(state) {
    state.productNavResetEpoch = (state.productNavResetEpoch || 0) + 1;
  },
  SET_LAST_BILL_ID(state, val) {
    if(val === null || val === undefined) {
      state.lastBillId++;
    }else {
      state.lastBillId = val;
    }
  },
  SET_PAYMENT_METHODS(state, val) {
    state.paymentMethods = val;
  },
  SET_SELECTED_PAYMENT_METHOD(state, val) {
    if (!val) {
      state.selectedPaymentMethod = null;
      return;
    }
    let methods = (state.paymentMethods || []).map((data) => {
      if (data && val && data.id == val.id) data.selected = true;
      else if (data) data.selected = false;
      return data;
    });
    state.paymentMethods = methods;
    state.selectedPaymentMethod = val;
  },
  SET_ACTIVE_PERSONAL_USER_CODE(state, val) {
    state.activePersonal.userCode = val;
  },
  SET_LOSS_MODE(state, val) {
    state.isLossModeOn = val;
  },
  SET_LOSS_TYPE(state, val) {
    state.lossTypeSelection = val;
  },
  ADD_SELECTED_LOSS_STOCK(state, val) {
    state.selectedLossStocks.unshift(val);
  },
  CLEAR_SELECTED_LOSS_STOCKS(state) {
    state.selectedLossStocks = [];
  },
  REMOVE_SELECTED_LOSS_STOCK(state, stockId) {
    let stockIndex = state.selectedLossStocks.findIndex(x => x.id == stockId);
    state.selectedLossStocks.splice(stockIndex, 1);
  },
  SET_CAKE_QUESTIONED(state, bool) {
    state.isCakeQuestioned = bool;
    if(!bool) {
      state.hasNeedNavigationByQuestion = false;
    }
  },
  SET_CURRENT_CART_CUSTOMER(state, customer) {
    let currentCart = state.carts.find(x => x.active);
    if (!currentCart) return;
    if (customer == null) {
      delete currentCart.customer;
      delete currentCart.campaignGiftId;
      delete currentCart.customerGiftId;
      delete currentCart.partnerQr;
      (currentCart.cartEntries || []).forEach(item => {
        const orig = item.originPrice || item.OriginPrice || item.beforeGiftPrice;
        if (orig != null && orig > 0) {
          item.price = orig;
        }
        delete item.giftAction;
        delete item.GiftAction;
        delete item.giftActionPrice;
        delete item.GiftActionPrice;
        item.forCampaign = 0;
        item.ForCampaign = 0;
      });
      currentCart.totalPrice = 0;
      (currentCart.cartEntries || []).forEach(item => {
        currentCart.totalPrice += Number(item && item.price) || 0;
      });
      currentCart.totalPrice = Math.round(currentCart.totalPrice * 100) / 100;
    } else {
      currentCart.customer = {};
      Object.assign(currentCart.customer, customer);
      delete currentCart.partnerQr;
    }
  },
  SET_CURRENT_CART_PARTNER_QR(state, partner) {
    let currentCart = state.carts.find(x => x.active);
    if (!currentCart) return;
    if (partner == null) {
      delete currentCart.partnerQr;
      delete currentCart.campaignGiftId;
      delete currentCart.customerGiftId;
      (currentCart.cartEntries || []).forEach(item => {
        const orig = item.originPrice || item.OriginPrice || item.beforeGiftPrice;
        if (orig != null && orig > 0) {
          item.price = orig;
        }
        delete item.giftAction;
        delete item.GiftAction;
        delete item.giftActionPrice;
        delete item.GiftActionPrice;
        item.forCampaign = 0;
        item.ForCampaign = 0;
      });
      currentCart.totalPrice = 0;
      (currentCart.cartEntries || []).forEach(item => {
        currentCart.totalPrice += Number(item && item.price) || 0;
      });
      currentCart.totalPrice = Math.round(currentCart.totalPrice * 100) / 100;
    } else {
      currentCart.partnerQr = {
        qrCode: partner.qrCode,
        name: partner.name,
        partnerCampaignQrId: partner.partnerCampaignQrId
      };
      delete currentCart.customer;
      delete currentCart.customerGiftId;
      delete currentCart.campaignGiftId;
    }
  },
  SET_NAVIGATION_QUESTION(state, question) {
    Object.assign(state.navigationQuestion, question)
  },
  HAS_NEED_NAVIGATION_BY_QUESTION(state, payload) {
    state.hasNeedNavigationByQuestion = payload
  },
  SET_CURRENT_CART_NAVIGATED_BY_QUESTION(state) {
    let currentCart = state.carts.find(x => x.active);
    currentCart.isNavigatedByQuestion = true;
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  SET_DISCOUNT_REASONS(state, discountReasons) {
    state.discountReasons = discountReasons;
  },
  SET_PAYMENT_SESSION_STATE(state, payload) {
    state.paymentSessionState = { ...state.paymentSessionState, ...payload };
  },
  CLEAR_PAYMENT_SESSION_STATE(state) {
    state.paymentSessionState = {
      isActive: false,
      cloneCurrentCart: null,
      paymentGroups: [],
      orderPayments: [],
      discounts: [],
      isPaymentStarted: false,
      isPieced: false
    };
  }
};
